import React from "react";

const YMRSForm = ({ formData, handleChange }) => {
    const questions = [
        {
            id: "elevatedMood",
            title: "1. Elevated Mood",
            options: [
                { value: 0, label: "Absent" },
                { value: 1, label: "Mildly or possibly increased on questioning" },
                { value: 2, label: "Definite subjective elevation; optimistic; self-confident; cheerful; appropriate to content" },
                { value: 3, label: "Elevated, inappropriate to content; humorous" },
                { value: 4, label: "Euphoric; inappropriate laughter, singing" }
            ]
        },
        {
            id: "motorActivity",
            title: "2. Increased Motor Activity/Energy",
            options: [
                { value: 0, label: "Absent" },
                { value: 1, label: "Subjectively increased" },
                { value: 2, label: "Animated; gestures increased" },
                { value: 3, label: "Excessive energy; hyperactive at times; restless (can be calmed)" },
                { value: 4, label: "Motor excitement; continuous hyperactivity (cannot be calmed)" }
            ]
        },
        {
            id: "sexualInterest",
            title: "3. Sexual Interest",
            options: [
                { value: 0, label: "Normal; not increased" },
                { value: 1, label: "Mildly or possibly increased" },
                { value: 2, label: "Definite subjective increase on questioning" },
                { value: 3, label: "Spontaneous sexual content; elaborates on sexual matters; hypersexual by self-report" },
                { value: 4, label: "Overt sexual acts (toward patients, staff, or interviewer)" }
            ]
        },
        {
            id: "sleep",
            title: "4. Sleep",
            options: [
                { value: 0, label: "Reports no decrease in sleep" },
                { value: 1, label: "Sleeping less than normal amount by up to one hour" },
                { value: 2, label: "Sleeping less than normal by more than one hour" },
                { value: 3, label: "Reports decreased need for sleep" },
                { value: 4, label: "Denies need for sleep" }
            ]
        },
        {
            id: "irritability",
            title: "5. Irritability",
            options: [
                { value: 0, label: "Absent" },
                { value: 2, label: "Subjectively increased" },
                { value: 4, label: "Irritable at times during interview; recent episodes of anger or annoyance on ward" },
                { value: 6, label: "Frequently irritable during interview; short or curt throughout" },
                { value: 8, label: "Hostile, uncooperative; interview impossible" }
            ]
        },
        {
            id: "speech",
            title: "6. Speech (Rate and Amount)",
            options: [
                { value: 0, label: "No increase" },
                { value: 2, label: "Feels talkative" },
                { value: 4, label: "Increased rate or amount at times, verbose at times" },
                { value: 6, label: "Push; consistently increased rate and amount; difficult to interrupt" },
                { value: 8, label: "Pressured; uninterruptible, continuous speech" }
            ]
        },
        {
            id: "thoughtDisorder",
            title: "7. Language/Thought Disorder",
            options: [
                { value: 0, label: "Absent" },
                { value: 1, label: "Circumstantial; mild distractibility; quick thoughts" },
                { value: 2, label: "Distractible; loses goal of thought; changes topics frequently; racing thoughts" },
                { value: 3, label: "Flight of ideas; tangentiality; difficult to follow; rhyming; echolalia" },
                { value: 4, label: "Incoherent; communication impossible" }
            ]
        },
        {
            id: "thoughtContent",
            title: "8. Thought Content",
            options: [
                { value: 0, label: "Normal" },
                { value: 2, label: "Questionable plans; new interests" },
                { value: 4, label: "Special project(s); hyper-religious" },
                { value: 6, label: "Grandiose or paranoid ideas; ideas of reference" },
                { value: 8, label: "Delusions; hallucinations" }
            ]
        },
        {
            id: "disruptiveBehavior",
            title: "9. Disruptive/Aggressive Behavior",
            options: [
                { value: 0, label: "Absent, cooperative" },
                { value: 2, label: "Sarcastic; loud at times, guarded" },
                { value: 4, label: "Demanding; threats on ward" },
                { value: 6, label: "Threatens interviewer; shouting; interview difficult" },
                { value: 8, label: "Assaultive; destructive; interview impossible" }
            ]
        },
        {
            id: "appearance",
            title: "10. Appearance",
            options: [
                { value: 0, label: "Appropriate dress and grooming" },
                { value: 1, label: "Minimally unkempt" },
                { value: 2, label: "Poorly groomed; moderately disheveled; overdressed" },
                { value: 3, label: "Disheveled; partly clothed; garish makeup" },
                { value: 4, label: "Completely unkempt; decorated; bizarre garb" }
            ]
        },
        {
            id: "insight",
            title: "11. Insight",
            options: [
                { value: 0, label: "Present; admits illness; agrees with need for treatment" },
                { value: 1, label: "Possibly ill" },
                { value: 2, label: "Admits behavior change, but denies illness" },
                { value: 3, label: "Admits possible change in behavior; but denies illness" },
                { value: 4, label: "Denies any behavior change" }
            ]
        }
    ];


    return (
        <>
            {/* Sticky Guidelines Button */}
            <div className="row mb-4 position-sticky top-0 bg-white pt-3" style={{ zIndex: 10 }}>
                <div className="col-md-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#ymrsGuidelines"
                    >
                        <i className="ri-information-line me-2"></i>
                        YMRS Guidelines & Scoring
                    </button>
                </div>
            </div>
            <div className="p-3" style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="ymrsAccordion">
                    {/* Client Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#clientInfo">
                                Client Information
                            </button>
                        </h2>
                        <div id="clientInfo" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="patientName"
                                                value={formData.patientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId} // ⭐ ADD THIS PROPERTY TO LOCK INPUT BOX ⭐
                                            />
                                            <label>Patient Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="date" value={formData.date || ""} onChange={handleChange} />
                                            <label>Date</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="assessedBy" value={formData.assessedBy || ""} onChange={handleChange} />
                                            <label>Assessed By</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* YMRS Items - All in one collapsible section */}
                    <div className="accordion-item mb-5 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center mb-3">
                            <button
                                className="accordion-button fw-semibold"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#ymrsSection"
                            >
                                Young Mania Rating Scale (YMRS) – 11 Items
                            </button>
                            {/* Info Button (round) */}
                            <div className="d-flex align-items-center mx-2">
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle"
                                    style={{ width: 32, height: 32 }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ymrsInstructionsModal"
                                >
                                    <i className="ri-information-line fs-6"></i>
                                </button>
                            </div>
                        </h2>
                        <div id="ymrsSection" className="accordion-collapse collapse show">
                            <div className="accordion-body">
                                {/* Each YMRS Item - Collapsible */}
                                {questions.map((q) => (
                                    <div className="accordion-item mb-3 shadow-sm rounded" key={q.id}>
                                        <h2 className="accordion-header">
                                            <button
                                                className="accordion-button collapsed fw-medium"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#item_${q.id}`}
                                            >
                                                {q.title}
                                            </button>
                                        </h2>
                                        <div id={`item_${q.id}`} className="accordion-collapse collapse">
                                            <div className="accordion-body pt-3">
                                                <div className="row g-4">
                                                    {q.options.map((opt) => (
                                                        <div className="col-md-12" key={opt.value}>
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name={q.id}
                                                                    id={`${q.id}_opt${opt.value}`}
                                                                    value={opt.value}
                                                                    checked={String(formData[q.id]) === String(opt.value)}
                                                                    onChange={handleChange}
                                                                />
                                                                <label className="form-check-label fw-medium d-flex align-items-start"
                                                                    htmlFor={`${q.id}_opt${opt.value}`}>
                                                                    <span className="text-primary fw-bold me-3">{opt.value}</span>
                                                                    <span>{opt.label}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Guidelines Modal */}
                <div className="modal fade" id="ymrsGuidelines" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p className="small">
                                    The purpose of each item is to rate the severity of that abnormality in the patient. When several keys are given for a particular grade of severity, the presence of only one is required to qualify for that rating. A severity rating is assigned to each of the eleven items, based on the patient’s subjective report of his or her condition over the previous forty-eight hours and the clinician’s behavioral observations during the interview, with the emphasis on the latter.
                                </p>
                                <p className="small">
                                    Scoring between the points given (whole or half points) is possible and encouraged after experience with the scale is acquired. This is particularly useful when severity of a particular item in a patient does not follow the progression indicated by the keys.
                                </p>
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                    In scoring the YMRS, the following items are graded on a 0 to 8 scale:
                                </small>
                                <ul className="small row col-12">
                                    <li className="col-6">Irritability</li>
                                    <li className="col-6">Speech</li>
                                    <li className="col-6">Thought content</li>
                                    <li className="col-6">Disruptive/aggressive behavior</li>
                                </ul>
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                    The following items are graded on a 0 to 4 scale:
                                </small>

                                <ul className="small row col-12">
                                    <li className="col-6">Elevated mood</li>
                                    <li className="col-6">Increased motor activity/energy</li>
                                    <li className="col-6">Sexual interest</li>
                                    <li className="col-6">Sleep</li>
                                    <li className="col-6">Language/thought disorder</li>
                                    <li className="col-6">Appearance</li>
                                    <li className="col-6">Insight</li>
                                </ul>
                                {/* <p className="small">
                                    Citation: Young RC, Biggs JT, Ziegler VE, Meyer DA: A rating scale for mania: reliability, validity and sensitivity. British Journal of Psychiatry 133:429-435, 1978.
                                </p> */}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* YMRS Instructions Modal */}
                <div className="modal fade" id="ymrsInstructionsModal" tabIndex="-1">
                    <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p className="small">
                                    Instructions: For each item below, circle the response that best describes how you felt or behaved during the past 48 hours.
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default YMRSForm;